import { render, staticRenderFns } from "./PaginaImportaTracciatiBiglietteria.vue?vue&type=template&id=e1005648"
import script from "./PaginaImportaTracciatiBiglietteria.vue?vue&type=script&lang=js"
export * from "./PaginaImportaTracciatiBiglietteria.vue?vue&type=script&lang=js"
import style0 from "./PaginaImportaTracciatiBiglietteria.vue?vue&type=style&index=0&id=e1005648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports